if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.viewer = this.querySelector('.product-gallery__slides');
        this.thumbnails = this.querySelector('.product-gallery__thumbs');

        if (this.thumbnails) {
          this.thumbnails.querySelectorAll('[data-target]').forEach((button) => {
            button.addEventListener('click', () => this.setActiveMedia(button.dataset.target, false));
          });
        }
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.viewer.querySelector(`[data-media-id="${mediaId}"]`) || this.viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;

        this.viewer.querySelectorAll('[data-media-id]').forEach((element) => element.classList.remove('is-active'));
        activeMedia.classList.add('is-active');

        if (prepend && activeMedia.parentElement.firstChild !== activeMedia) {
          activeMedia.parentElement.prepend(activeMedia);
        }

        if (this.thumbnails) {
          const activeThumbnail = this.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(activeThumbnail, prepend);
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          window.scrollTo({ top: activeMediaRect.top + window.scrollY, behavior: 'smooth' });
        });
      }

      setActiveThumbnail(thumbnail, prepend) {
        if (!thumbnail) return;

        this.thumbnails.querySelectorAll('[data-target]').forEach((button) => button.removeAttribute('aria-current'));
        thumbnail.setAttribute('aria-current', 'true');

        if (prepend && thumbnail.parentElement.firstChild !== thumbnail) {
          thumbnail.parentElement.prepend(thumbnail);
        }

        const viewport = this.thumbnails.querySelector('.product-gallery__thumb-viewport');
        const swiper = viewport && viewport.swiper;
        if (!swiper) return;
        const index = [...thumbnail.parentElement.children].indexOf(thumbnail);
        swiper.slideTo(index);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }
    }
  );
}
